<h2>Análise de Relatório - {{ dataFormatada }}</h2>
<p>{{ data.texto }}</p>
